import React, { useContext, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import classNames from 'classnames/bind';
import styles from './NavBar.module.scss';
import avatar from '~/assets/avatar.png'; // Import avatar image
import { ScrollEventContext } from '../Context/ScrollEventProvider';
import { NavbarInforContext } from '../Context/NavbarInforPrivider';
import { ScrolledPastContext } from '../Context/ScrolledPastProvder';
import routes from '~/configs';
import { scrollToBottom } from '~/helper/scroll';

const cx = classNames.bind(styles);

const navs = [
  {
    to: routes.home,
    title: 'Trang chủ',
  },
  {
    to: routes.cV,
    title: 'CV',
  },
  {
    to: routes.post,
    title: 'Bài đăng',
  },
  {
    to: routes.projects,
    title: 'Dự án',
  },
  {
    to: routes.about,
    title: 'Giới thiệu',
  },
];

function NavBar({ fixed = true, col, transparent }) {
  const { scrollDirection } = useContext(ScrollEventContext);

  const { navIndexActive, setNavIndexActive } = useContext(NavbarInforContext);

  const { refNav, isPin, setIsPin } = useContext(ScrolledPastContext);

  const [fobiden] = useState(false);
  const location = useLocation();

  const handleClickItemNav = (index) => {
    setNavIndexActive(index);
    setIsPin(false);

    if(index === navIndexActive){
      scrollToBottom(refNav); 
    }
  };

  return (
    <nav className={cx('navbar', { transparent: transparent })} ref={refNav}>
      <div
        className={cx('navbar-container', {
          pin: isPin && fixed,
          // bound: bound,
          show: scrollDirection === 'up',
          hide: scrollDirection === 'down' && !fobiden,
        })}
      >
        <ul className={cx('navbar-menu', { col: col })}>
          {navs.map((nav, index) => (
            <li className={cx('navbar-item')} key={index}>
              <NavLink
                to={nav.to}
                className={cx('navbar-link',{ active: location.pathname === nav.to })}
                onClick={() => handleClickItemNav(index)}
              >
                <img alt="" src={avatar} />
                <span className={cx('navbar-item-text')}>{nav.title}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}

export default NavBar;
